import { $api } from '@shared/api';

export const uploadFile = async (formData: FormData) => {
    // @ts-ignore
    const url = routable.getRoute('addFiles');
    try {
        const res = await $api.post<any>(`${url}`, formData);
        return res;
    } catch (error) {
        return error?.response?.data;
    }
};

// export const uploadFile = createAsyncThunk('files/uploadFile', async (formData, thunkApi) => {
//     const addFilesUrl = routable.getRoute('addFiles');
//     try {
//         const addFilesResponse = await fetch(addFilesUrl, {
//             method: 'POST',
//             body: formData,
//             headers: {
//                 'X-Requested-With': 'XMLHttpRequest',
//             },
//         });
//
//         if (!addFilesResponse.ok) {
//             const error = await addFilesResponse.json();
//             loader.hide();
//             swal({
//                 text: error.message,
//                 cancel: false,
//                 confirm: true,
//                 button: {
//                     text: i18next.t('filesSlice.action.fetchFiles.swal.button'),
//                     value: true,
//                     visible: true,
//                     className: 'btn btn-secondary',
//                 },
//             });
//             return thunkApi.rejectWithValue(error.message);
//         }
//
//         const { data } = await addFilesResponse.json();
//
//         return data;
//     } catch (e) {
//         return thunkApi.rejectWithValue(error.message ? error.message : error.toString());
//     }
// });
